import PrimaryButton from '../../ui-components/PrimaryButton'
import { trackEvent } from '../../../utils/appBridge'
import BottomSheetContent from '../../BottomSheetComponents/BottomSheetContent'
import { EventNames } from '../../../types/misc.types'
import RenderHTML from '../../ui-components/RenderHTML'
import { useState } from 'react'

const FamilyRiskProfilePromptSheet = ({
  onClose,
  onDestroy,
  onNavigate,
  familyMemberName: familyMemberName,
  consentText,
  familyMemberPhoneNumber,
  source = ''
}: {
  onClose: () => void
  onDestroy: () => void
  onNavigate: (path: string) => void
  familyMemberName: string
  consentText: string
  familyMemberPhoneNumber: string
  source?: string
}) => {
  const [isConsentChecked, setIsConsentChecked] = useState(true)

  return (
    <BottomSheetContent
      onDismiss={onClose}
      bottomSheetCtas={
        <PrimaryButton
          key='close'
          label='Send OTP'
          onClick={() => {
            if (!isConsentChecked) return
            trackEvent({
              eventName: EventNames.UserClicked,
              payload: {
                eventId: 'RiskProfileBottomSheetClicked'
              }
            })
            onDestroy()
            onNavigate(
              `/rebalance-questionnaire-otp?phoneNumber=${familyMemberPhoneNumber}${source ? `&from=${source}` : ''}`
            )
          }}
          isFullWidth
          disabled={!isConsentChecked}
          labelClassName=''
        />
      }
      bottomSheetBodyClassName='pb-0 !px-0'
      bottomSheetHeadClassName='!pt-0'
    >
      <div className='w-full h-full flex flex-col'>
        <div className='flex flex-col'>
          <img src='/images/power-rebalance/risk-profile.png' className='w-full h-full' />
        </div>
        <div className='px-5'>
          <div className='text-[22px] leading-[130%] font-[400] text-[#232323]'>
            <span className='font-[700]'>
              {' '}
              {familyMemberName ? familyMemberName?.split(' ')?.[0] : 'Your family member'} needs to complete{' '}
            </span>{' '}
            a <br />
            risk assessment from this phone
          </div>
          <div className='text-[14px] leading-[150%] font-[400] text-[#6A6E6E] pt-3 pb-8'>
            Answer 4 quick questions, and we’ll tailor recommendations based on their risk.
          </div>
        </div>

        {/* Consent Checkbox */}
        <div
          onClick={() => setIsConsentChecked(!isConsentChecked)}
          className='flex items-start gap-3 cursor-pointer pl-6 pr-5 border-t border-[#EBF2F2] pt-5'
        >
          <div className='mt-1 flex-shrink-0'>
            <RenderHTML innerHTMLText={isConsentChecked ? CheckedBox : UncheckedBox} />
          </div>
          <div className='flex-1 text-[#6A6E6E] text-[12px] font-[400] leading-[150%] max-w-[90%]'>{consentText}</div>
        </div>
      </div>
    </BottomSheetContent>
  )
}

const UncheckedBox = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="5.25" stroke="#8E9393" stroke-width="1.5"/>
</svg>`

const CheckedBox = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <rect width="20" height="20" rx="6" fill="#3D3D3D"/>
  <path d="M5.41504 10.4199L7.9958 12.6781C8.41143 13.0418 9.0432 12.9996 9.40688 12.584L14.5817 6.66992" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

// Prompt bottom sheet when elite user has no risk profile
const RiskProfilePromptSheet = ({
  onClose,
  onNavigate
}: {
  onClose: () => void
  onNavigate: (path: string) => void
}) => {
  return (
    <BottomSheetContent
      onDismiss={onClose}
      bottomSheetCtas={
        <PrimaryButton
          key='close'
          label='Start'
          onClick={() => {
            trackEvent({
              eventName: EventNames.UserClicked,
              payload: {
                eventId: 'RiskProfileBottomSheetClicked'
              }
            })
            onClose()
            onNavigate('/rebalance-questionnaire')
          }}
          isFullWidth
          labelClassName=''
          disabled={false}
        />
      }
      bottomSheetBodyClassName='pb-0 !px-0'
      bottomSheetHeadClassName='!pt-0'
    >
      <div className='w-full h-full flex flex-col'>
        <div className='flex flex-col'>
          <img src='/images/power-rebalance/risk-profile.png' className='w-full h-full' />
        </div>
        <div className='px-5'>
          <div className='text-2xl font-medium text-black'>Start with determining your risk profile</div>
          <div className='text-sm text-grey40 mt-2'>
            Just answer 4 quick questions. So that recommendations are suited to your risk for current and future
            rebalancing plans.
          </div>
        </div>
      </div>
    </BottomSheetContent>
  )
}

export { FamilyRiskProfilePromptSheet, RiskProfilePromptSheet }
